import { combineReducers } from 'redux';

import basicState, { basicSelectedUserDetailsInitialState } from './basic';

export const selectedUserDetailsInitialState =  { 
  basicState: basicSelectedUserDetailsInitialState
}

export default combineReducers({ 
  basicState
})